export default () => {
  return {
    driversOptimiser: [],
    isLoadingDriversOptimiser: false,

    drivers: [],

    driversOptimiserCount: 0,

    filter: {
      limit: 25,
      offset: 0,
      actif: true,
    },
    driversSettings: [],
    driversSettingsCount: 0,
    isLoadingDriversSettingsList: false,
    errorMessage: null,
    isErrorFetch: false,

    isLoadingDriverSettingsAction: false,
    success: false,
    isSuccessRefresh: false,

    driversSettingsList: [],
    driversSettingsListCount: 0,
    isLoadingDriversSettings: false,
  }
}
